import * as yup from "yup";
export const InviteUsersSchema = yup.object({
    name1:yup.string().required("Please enter your First Name"),
    name2:yup.string().required("Please enter your Last Name"),
    email:yup.string().required("Please enter your Email").email("Please enter a valid Email"),
})